import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Select, MenuItem, FormControl, InputLabel, FormHelperText,Divider
} from "@mui/material";
import {
  ArrowForward,
  Shield,
  CheckCircle,
  ContentCopy,
  Notifications,
} from "@mui/icons-material";
import { useSnackbar } from "notistack";
import EnterPassKeyDialog from "./EnterPassKeyModal";
import { bridgeTransfer , getTransactionHistory , checkOptin , quickCheckOptin} from "../services/bridgeServices";
import userServices from "../services/userServices";
import AssetOptin from "./modals/OptinModal";

const BridgeModal = ({
  isOpen,
  onClose,
  sourceBlockchain,
  sourceAddress,
  maxTokens,
  listingId,
  entityId,
  entityType,
  rpf,
  senderAddress,
  userId,
  blockChainAssetId,
  isContinue = false,
  selectedTransactionId = null,
  prefilledAddress = '',
  prefilledTokens = ''
}) => {
  const { enqueueSnackbar } = useSnackbar();

  // Main flow states
  const [destinationAddress, setDestinationAddress] = useState(prefilledAddress);
  const [tokens, setTokens] = useState(prefilledTokens);
  const [errors, setErrors] = useState({});
  const [fromAddress, setFromAddress] = useState("");
  

  // Dialog control states
  const [enterPassKeyOpen, setEnterPassKeyOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [resultOpen, setResultOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultError, setResultError] = useState("");
  const [resultData, setResultData] = useState(null);
  const [availableBlockchainAccounts , setAvailableBlockchainAccounts] = useState([])
  const [isOptin, setIsOptin] = useState(true); 
  const [optinDialogOpen, setOptinDialogOpen] = useState(false);
  const [optinComponentOpen, setOptinComponentOpen] = useState(false);
  const [optinId, setOptinId] = useState("");
  const [currentTransactionId, setCurrentTransactionId] = useState(null);


  const targetBlockchain =
    sourceBlockchain === "Algorand" ? "Polygon" : "Algorand";
  const needsPasskey = sourceBlockchain === "Algorand";
  // console.log("sourse blockchain", sourceBlockchain , "target blockchain", targetBlockchain)
  // Reset modal when closing
  const resetState = () => {
    setDestinationAddress("");
    setTokens("");
    setErrors({});
    setFromAddress("");
    setEnterPassKeyOpen(false);
    setConfirmOpen(false);
    setResultOpen(false);
    setLoading(false);
    setResultError("");
    setResultData(null);
  };

  const handleClose = () => {
    resetState();
    onClose?.();
  };

  //fetch dlt account
  const fetchDltWallet = async () => {
     let network = targetBlockchain.toLowerCase()=="polygon"? 'polygon' : 'algorand';
      let dltWallet = await userServices.getDltWallet(entityId , network);
      setAvailableBlockchainAccounts(dltWallet.data);

    };

    //check optin
    const beforeOptin = async () => {
      let network = targetBlockchain.toLowerCase() === "polygon"
        ? "polygon"
        : "algorand";

      if (network === "algorand") {
        let data = {
          propertyId: listingId,
          amount: tokens,
          entityId,
          entityType,
          rpf,
          senderAddress,
          algoAddress: destinationAddress
        };

        let dltWallet = await checkOptin(data);

        console.log("optin check" , dltWallet?.data?.assetOptinCheck)
        // dltWallet.optinRequired → use whatever field your API returns
        if (dltWallet?.data?.assetOptinCheck === true) {
          console.log("is optin true")
          setCurrentTransactionId(dltWallet.data.currentTransactionId)
          // setIsOptin(true);   // already opted-in
        } else {
          console.log("is optin false")
          // setIsOptin(false); // need opt-in
        }
      }
    };

    const afterOptin = async () => {
      console.log("after optin called ====")
      let network = targetBlockchain.toLowerCase() === "polygon"
        ? "polygon"
        : "algorand";

      if (network === "algorand") {
        let data = {
          propertyId: listingId,
          amount: tokens,
          entityId,
          entityType,
          rpf,
          senderAddress,
          algoAddress: destinationAddress,
          transactionId: currentTransactionId ? currentTransactionId : null
        };

        let dltWallet = await checkOptin(data);

        console.log("optin check" , dltWallet?.data?.assetOptinCheck)
        // dltWallet.optinRequired → use whatever field your API returns
        if (dltWallet?.data?.assetOptinCheck === true) {
          console.log("is optin true")
          // handleStep1Submit()
          // setCurrentTransactionId(dltWallet.data.currentTransactionId)
           setIsOptin(true);   // already opted-in
        } else {
          console.log("is optin false")
           setIsOptin(false); // need opt-in
        }
      }
};

//check optin
    const quickCheckAssetOptin = async (dltAccount) => {
      let network = targetBlockchain.toLowerCase() === "polygon"
        ? "polygon"
        : "algorand";

      if (network === "algorand") {
        let data = {
          propertyId: listingId,
          algoAddress: dltAccount
        };

        let dltWallet = await quickCheckOptin(data);

        console.log("optin check" , dltWallet?.data?.assetOptinCheck)
        // dltWallet.optinRequired → use whatever field your API returns
        if (dltWallet?.data?.assetOptinCheck === true) {
          console.log("is optin true")
          setIsOptin(true);   // already opted-in
          setCurrentTransactionId(dltWallet?.data?.currentTransactionId)
        } else {
          console.log("is optin false")
          setIsOptin(false);  // need opt-in
        }

        return dltWallet?.data?.assetOptinCheck;
      }

      return;
};


    // console.log(availableBlockchainAccounts)

  // Step 1 submit — validate & continue
  const handleStep1Submit = async(e) => {
    console.log("handle step 1 called")
    e.preventDefault();
    const newErrors = {};

    if (!destinationAddress.trim())
      newErrors.address = "Destination address is required";

    const tokenAmount = parseFloat(tokens);
    if (!tokens || isNaN(tokenAmount) || tokenAmount <= 0) {
      newErrors.tokens = "Please enter a valid number of tokens";
    } else if (tokenAmount > maxTokens) {
      newErrors.tokens = `Maximum ${maxTokens.toLocaleString()} tokens available`;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }


    if(targetBlockchain.toLowerCase() == 'algorand'){

      // console.log("optinDialogOpen" , isOptin)

      const isOptinCheck = await quickCheckAssetOptin(destinationAddress);

      if(!isOptinCheck){
        setOptinDialogOpen(true);
        return;
      }
    }
    


    // if Algorand → Polygon, open passkey dialog
    // if (needsPasskey) {
    //   setEnterPassKeyOpen(true);
    // } else {
    //   // direct confirm if no passkey required
    //   setConfirmOpen(true);
    // }

    setEnterPassKeyOpen(true);
    // setConfirmOpen(true);
  };

  const handleTransfer = async () => {
    setConfirmOpen(false);
    setLoading(true);

    try {
      let payload = {
        propertyId: listingId,
        amount: tokens,
        entityId,
        entityType,
        rpf,
        senderAddress
      };

      if (sourceBlockchain === "Polygon" && targetBlockchain === "Algorand") {
        let transactionId = currentTransactionId;
        if(isContinue && selectedTransactionId){
          transactionId = selectedTransactionId
        }
        payload = {
          ...payload,
          algoAddress: destinationAddress,
          privateKey: fromAddress,
          transactionId : transactionId
        };
      } else if (sourceBlockchain === "Algorand" && targetBlockchain === "Polygon") {
        payload = {
          ...payload,
          to: destinationAddress,
          userMnemonic: fromAddress,
        };
      } else {
        throw new Error("Unsupported chain combination");
      }

      const res = await bridgeTransfer(sourceBlockchain, targetBlockchain, payload);
      if (!res?.success) throw new Error(res?.message || "Transfer failed");

      const normalized = {
        algorandTx:
          typeof res.data?.algorandTx === "string"
            ? res.data.algorandTx
            : res.data?.algorandTx?.transactionId || null,
        polygonTx:
          typeof res.data?.polygonTx === "string"
            ? res.data.polygonTx
            : res.data?.polygon?.txHash || null,
        contract: res.data?.polygon?.contract || null,
      };

      setResultData(normalized);
      enqueueSnackbar("✅ Transfer Successful", { variant: "success" });
    } catch (e) {
      setResultError(e?.message || "Transfer failed");
      enqueueSnackbar(e?.message || "Transfer failed", { variant: "error" });
    } finally {
      setLoading(false);
      setResultOpen(true);
    }
  };

  useEffect(()=>{
    fetchDltWallet();
  },[targetBlockchain , entityId])

  return (
    <>
      {/* Step 1: Main Bridge Modal */}
      <Dialog
  open={isOpen && !enterPassKeyOpen && !confirmOpen && !loading && !resultOpen}
  onClose={handleClose}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Bridge Tokens</DialogTitle>
  <DialogContent>
    <form onSubmit={handleStep1Submit}>
      {/* From Section */}
      <Box mb={2}>
        <Typography variant="subtitle2">From</Typography>
        <TextField
          label="Blockchain"
          value={`${sourceBlockchain} FRAX`}
          fullWidth
          margin="dense"
          disabled
        />
        <TextField
          label="Account Address"
          value={sourceAddress}
          fullWidth
          margin="dense"
          disabled
          InputProps={{ style: { fontFamily: "monospace", fontSize: 12 } }}
        />
      </Box>

      <Box display="flex" justifyContent="center" my={2}>
        <ArrowForward fontSize="large" />
      </Box>

      {/* To Section */}
      <Box mb={2}>
        <Typography variant="subtitle2">To</Typography>
        <TextField
          label="Blockchain"
          value={`${targetBlockchain} FRAX`}
          fullWidth
          margin="dense"
          disabled
        />

        {isContinue ? (
          // Continue transaction: read-only prefilled values
          <TextField
            label="Account Address"
            value={prefilledAddress}
            fullWidth
            margin="dense"
            disabled
            InputProps={{ style: { fontFamily: "monospace", fontSize: 12 } }}
          />
        ) : (
          // Initial transfer: dropdown with validation
          <FormControl fullWidth margin="dense" error={!!errors.address}>
            <InputLabel>{`${targetBlockchain} Account Address *`}</InputLabel>
            <Select
              value={destinationAddress}
              label={`${targetBlockchain} Account Address *`}
              onChange={(e) => {
                setDestinationAddress(e.target.value);
                if (errors.address) setErrors({ ...errors, address: undefined });
              }}
              sx={{ fontFamily: "monospace", fontSize: 12 }}
            >
              {availableBlockchainAccounts.map((item) => (
                <MenuItem key={item._id} value={item.publicAddress}>
                  <Box sx={{ width: "100%" }}>
                    {/* Name */}
                    <div style={{ fontWeight: 600 }}>
                      {item.name}
                    </div>

                    {/* Address */}
                    <div 
                      style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        fontFamily: "monospace",
                        fontSize: "12px",        // smaller text
                        color: "#777"            // lighter color
                      }}
                    >
                      {/* first 6 */}
                      {/* <span>{item.publicAddress.slice(0, 6)}</span> */}

                      {/* dotted line */}
                      {/* <span 
                        style={{ 
                          flex: 1, 
                          borderBottom: "1px dotted #ccc", 
                          margin: "0 6px" 
                        }} 
                      /> */}

                      {/* last 6 */}
                      <span>{item.publicAddress}</span>
                    </div>
                  </Box>


                </MenuItem>
              ))}
            </Select>
            {errors.address && <FormHelperText>{errors.address}</FormHelperText>}
          </FormControl>
        )}
      </Box>

      {/* Tokens */}
      <Box mb={2}>
        <TextField
          label="Number of Tokens to Transfer *"
          type="number"
          value={isContinue ? prefilledTokens : tokens}
          onChange={isContinue ? undefined : (e) => {
            setTokens(e.target.value);
            if (errors.tokens) setErrors({ ...errors, tokens: undefined });
          }}
          fullWidth
          margin="dense"
          disabled={isContinue} // <-- make field completely non-editable
          inputProps={isContinue ? { readOnly: true } : { max: maxTokens, step: 1 }}
          error={!!errors.tokens && !isContinue}
          helperText={!isContinue ? errors.tokens || `Available: ${maxTokens.toLocaleString()} FRAX` : ""}
        />
      </Box>

      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button type="submit" variant="contained">
          Continue
        </Button>
      </DialogActions>
    </form>
  </DialogContent>
</Dialog>


      {/* Step 2: Passkey Dialog */}
      <EnterPassKeyDialog
        open={enterPassKeyOpen}
        onClose={() => {setEnterPassKeyOpen(false) }}
        network={sourceBlockchain}
        setFromAddress={(value) => {
          setFromAddress(value);
          setEnterPassKeyOpen(false);
          setConfirmOpen(true);
        }}
      />

      {/* Dialog box to proceed for assetoptin */}
      <Dialog
        open={optinDialogOpen}
        onClose={() => setOptinDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Opt-In Required</DialogTitle>
        <DialogContent>
          <Typography mb={2}>
            To proceed with this transfer, your Algorand account must opt-in to the asset.
            This is required once per asset and allows your wallet to receive tokens.
          </Typography>

          <DialogActions>
            <Button onClick={() => setOptinDialogOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                const id = `${destinationAddress}&${userId}&${blockChainAssetId}`;
                setOptinId(id);
                setOptinDialogOpen(false);
                setOptinComponentOpen(true);
                beforeOptin();
              }}
            >
              Proceed to Opt-In
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

       {/* Dialog box on proceed to optin */}
      <Dialog
      open={optinComponentOpen}
      onClose={() => {setOptinComponentOpen(false); quickCheckAssetOptin(destinationAddress)}}
      fullWidth
      maxWidth="xl"
    >
      <DialogTitle>Asset Opt-In</DialogTitle>
      
      <DialogContent dividers>
        <AssetOptin id={optinId} 
        onOptinSuccess={() => {
        setOptinComponentOpen(false);      // function 1
        afterOptin(); // function 2
      }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOptinComponentOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>



      {/* Step 3: Confirm Dialog */}
      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleTransfer}
        fraxAmount={tokens}
        fromBlockchain={sourceBlockchain}
        toBlockchain={targetBlockchain}
        sourceAddress = {sourceAddress}
        destinationAddress = {destinationAddress}
      />

      {/* Step 4: Loading Spinner */}
      <Dialog open={loading} fullWidth maxWidth="xs">
        <DialogContent sx={{ py: 5, textAlign: "center" }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>
           Processing transfer... please do not close this window or interrupt.  
           This may take a few moments.
          </Typography>
        </DialogContent>
      </Dialog>

      {/* Step 5: Result Dialog */}
      <ResultDialog
        open={resultOpen}
        onClose={handleClose}
        loading={false}
        error={resultError}
        result={resultData}
      />
    </>
  );
};

/* --- Supporting Components --- */
function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  fraxAmount,
  fromBlockchain,
  toBlockchain,
  sourceAddress,
  destinationAddress,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Shield style={{ color: "#eb253f", marginRight: 8 }} />
          Confirm Transfer
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ background: "#f8fafc", p: 2, borderRadius: 2 }}>
          <Row label="Amount">{fraxAmount || "—"} FRAX</Row>
          <Row label="From">{fromBlockchain}</Row>
          <Row label="To">{toBlockchain}</Row>
          <Divider sx={{ my: 1 }} />
          <Row label="Sender Address">
            <Typography
              variant="body2"
              sx={{
                wordBreak: "break-all",
                color: "text.secondary",
              }}
            >
              {sourceAddress || "—"}
            </Typography>
          </Row>
          <Row label="Reciever Address">
            <Typography
              variant="body2"
              sx={{
                wordBreak: "break-all",
                color: "text.secondary",
              }}
            >
              {destinationAddress || "—"}
            </Typography>
          </Row>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          This action cannot be undone. Please verify all details before proceeding.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          
        >
          Confirm Transfer
        </Button>
      </DialogActions>
    </Dialog>
  );
}


function ResultDialog({ open, onClose, error, result }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {error ? (
            <Notifications sx={{ color: "#dc2626", mr: 1 }} />
          ) : (
            <CheckCircle sx={{ color: "#16a34a", mr: 1 }} />
          )}
          {error ? "Transfer Failed" : "Transfer Result"}
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <Box sx={{ background: "#f8fafc", p: 2, borderRadius: 2 }}>
            {result?.algorandTx && (
              <Row label="Algorand Tx">
                <CopyRow value={result.algorandTx} />
              </Row>
            )}
            {result?.polygonTx && (
              <Row label="Polygon Tx">
                <CopyRow value={result.polygonTx} />
              </Row>
            )}
            {result?.contract && (
              <Row label="Contract Address">
                <CopyRow value={result.contract} />
              </Row>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

function Row({ label, children }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        py: 0.75,
        borderBottom: "1px dashed #e5e7eb",
        "&:last-of-type": { borderBottom: "none" },
      }}
    >
      <Typography variant="body2" sx={{ color: "text.secondary", mr: 2 }}>
        {label}:
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {children}
      </Typography>
    </Box>
  );
}

function CopyRow({ value }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {value}
      </Typography>
      <Tooltip title="Copy">
        <IconButton
          size="small"
          onClick={() => navigator.clipboard.writeText(value)}
        >
          <ContentCopy fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default BridgeModal;
